import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@material-ui/core';

import { EeDialog } from 'pages/Scenarios/components/EeDialog';
import { EeConfirmDialog } from 'pages/Scenarios/components/EeConfirmDialog';
import { EeInput } from 'pages/Scenarios/components/EeInput';
import { EeNumber } from 'pages/Scenarios/components/EeNumber';
import { EeDatePicker } from 'pages/Scenarios/components/EeDatePicker';

import './style.scss';

export function ScenarioSettings(props: any) {
  const [index2delete, setIndex2delete] = useState<number | null>(null);
  const [deletedScenarios, setDeletedScenarios] = useState<any[]>([]);
  const [scenarioRows, setScenarioRows] = useState(props.scenarios);
  const [settingsIsOpen, setSettingsIsOpen] = useState(props.open);

  const { register, control, handleSubmit, getValues } = useForm();

  const deleteRow = (index2delete: number) =>
    setScenarioRows(() => {
      let scenarios = getValues().scenarioRows.map((scenario: any) => ({
        ...scenario,
        defaultDilution: parseFloat(scenario.defaultDilution) / 100,
      }));
      // Add the scenario to delete only if ID exists (scenario exists on the server)
      if (scenarios[index2delete].id) {
        const deleted = scenarios[index2delete];
        setDeletedScenarios([...deletedScenarios, deleted]);
      }
      return scenarios
        .filter((s: any, index: number) => index !== index2delete)
        .map((sr: any, i: number) => ({
          ...sr,
          position: i,
        }));
    });

  const addRow = () =>
    setScenarioRows((prevScenarios: any) => {
      const newScenario = {
        name: `Scenario #${prevScenarios.length + 1}`,
        //todo(vmyshko): use moment instead?
        position: prevScenarios.length,
        defaultExitDate: '2022-01-01',
        defaultDilution: 0,
      };

      return [...prevScenarios, newScenario];
    });

  const onSubmit = (data: any) => {
    const scenarios = (data.scenarioRows ?? []).map((sr: any, i: number) => ({
      ...sr,
      //todo(vmyshko): add proper mapping or fix the field itself to return numbers
      defaultDilution: parseFloat(sr.defaultDilution) / 100,
      position: i,
    }));

    props?.onSubmit(scenarios, deletedScenarios);
    cancel();
  };

  function cancel() {
    setScenarioRows([]);
    setSettingsIsOpen(false);
    props?.onClose();
  }

  if (!settingsIsOpen) return null;

  const setIndexToDeleteAction = (index: any) => {
    setIndex2delete(index);
  };

  const showConfirmDialog = (index: number|null) => {
    if (index) {
      const scenario = props.scenarios[index];
      if (
        scenario.name == `Scenario #${index + 1}` &&
        scenario.position == index &&
        scenario.defaultExitDate == '2022-01-01' &&
        scenario.defaultDilution == 0 &&
        !scenario.bookValue &&
        !scenario.grossIrr &&
        !scenario.grossMultiple &&
        !scenario.investedCapital
      ) {
        deleteRow(index as number);
        setIndex2delete(null);
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  return (
    <EeDialog
      className="scenario-model"
      width="760"
      open={settingsIsOpen}
      title={
        <span className="d-flex align-items-center">
          <i className="material-icons material-icons-outlined mr-3">
            settings
          </i>
          Scenario Settings
        </span>
      }
      confirmButtonLabel="save"
      onCancel={cancel}
      onConfirm={() => {
        handleSubmit(onSubmit)();
      }}
      header={
        <span className="d-flex my-4" style={{ color: '#1e1e1e' }}>
          Please set the below settings for fund level scenarios.
        </span>
      }
    >
      <EeConfirmDialog
        open={showConfirmDialog(index2delete)}
        confirmButtonLabel="Delete"
        onCancel={() => setIndex2delete(null)}
        onConfirm={() => {
          deleteRow(index2delete as number);
          setIndex2delete(null);
        }}
      >
        <p className="fs-16 mb-0">
          You are deleting Scenario "
          {getValues(`scenarioRows[${index2delete}].name`)}"
        </p>
        <p className="fs-14 mb-0">
          It will be removed from fund as well as company level.
        </p>
      </EeConfirmDialog>

      <div className="scenario-grid">
        <form className="d-contents">
          <div className="d-contents fs-12  text-uppercase">
            <div className="cell_name">scenario name</div>
            <div className="cell_dilution">default dilution</div>
            <div className="cell_exitdate">default exit date</div>
            <div />
          </div>

          {scenarioRows.length === 0 && (
            <div className="grid-no-data p-2 bg-light text-center">
              no scenarios
            </div>
          )}

          {scenarioRows?.map((scenario: any, index: number) => {
            const fieldName = `scenarioRows[${index}]`;
            return (
              <div className="d-contents" key={index + scenario.name}>
                <input
                  hidden
                  className=""
                  name={`${fieldName}.id`}
                  value={scenario.id}
                  readOnly
                  ref={register}
                />

                <EeInput
                  className="cell_name"
                  name={`${fieldName}.name`}
                  defaultValue={scenario.name}
                  register={register}
                  inputProps={{
                    maxLength: 24,
                  }}
                />

                <EeNumber
                  className="cell_dilution"
                  name={`${fieldName}.defaultDilution`}
                  suffix="%"
                  min={0}
                  max={100}
                  register={register}
                  defaultValue={scenario.defaultDilution * 100}
                  control={control}
                />

                <EeDatePicker
                  className="cell_exitdate"
                  name={`${fieldName}.defaultExitDate`}
                  defaultValue={
                    scenario.defaultExitDate
                      ? scenario.defaultExitDate
                      : '2022-01-01'
                  }
                  register={register}
                />
                <Button
                  className="cell_delete d-flex justify-content-center fs-16"
                  color="primary"
                  disabled={scenarioRows?.length === 1}
                  size="small"
                  onClick={() => setIndexToDeleteAction(index)}
                >
                  <i className="material-icons px-2">remove_circle_outline</i>
                  Delete
                </Button>
              </div>
            );
          })}
        </form>
      </div>
      <Button
        color="primary"
        className="my-3 mx-1"
        size="small"
        hidden={scenarioRows?.length === 3}
        onClick={() => addRow()}
        style={{ fontSize: '16px' }}
      >
        <i className="material-icons px-2">add_circle_outline</i>
        Add
      </Button>
    </EeDialog>
  );
}
